// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"99386c53","394":"2c0d3b16","597":"7d37bdfa","626":"963d7901","629":"1bcb6d26","841":"e5f489ec","922":"058fc23e","977":"b46cb0ea"}[chunkId] + ".chunk.css";
};